var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0H4C3.4 0 3 0.4 3 1V12C3 12.6 3.4 13 4 13H13C13.6 13 14 12.6 14 12V1C14 0.4 13.6 0 13 0ZM12 11H5V2H12V11Z",
    fill: "#393B48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H2V5C2 4.4 1.6 4 1 4C0.4 4 0 4.4 0 5V15C0 15.6 0.4 16 1 16H9C9.6 16 10 15.6 10 15C10 14.4 9.6 14 9 14Z",
    fill: "#393B48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5H10C10.6 5 11 4.6 11 4C11 3.4 10.6 3 10 3H7C6.4 3 6 3.4 6 4C6 4.6 6.4 5 7 5Z",
    fill: "#393B48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H10C10.6 8 11 7.6 11 7C11 6.4 10.6 6 10 6H7C6.4 6 6 6.4 6 7C6 7.6 6.4 8 7 8Z",
    fill: "#393B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.117e412be0daba94f68838b542c85f47.svg";
export { ForwardRef as ReactComponent };